import CCTextInput from "./CCTextInput";

export default CCTextInput;
